const { loadingPage } = require('./adqlo-loading');

// https://stackoverflow.com/questions/19491336/how-to-get-url-parameter-using-jquery-or-plain-javascript
function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Function to format the date as "yyyy-MM-dd HH:mm:ss"
function formatDate(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    var seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

$(document).ready(function() {
    var pathname = window.location.pathname;

    if (pathname == '/brand-social-report/pay') {
        var paid = getUrlParameter('paid');
        if (paid && paid == 1) {
            // add gtm Adqlo Pay Report Success , event : "Adqlo Pay Report Success"
            window.dataLayer.push({'event': 'Adqlo Pay Report Success'});

            window.location.href = '/brand-social-report/thank-you?id='+getUrlParameter('id');
        }
    } 
    // check status
    var report_id = getUrlParameter('id');
    if (report_id) {
        $.ajax({
            type: 'POST',
            url: "/brand-social-report/status",
            headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
            data: {"report_id":report_id},
            success: function(data) {
                const carousel = $('.owl-carousel');
                
                if (pathname == '/brand-social-report/thank-you' && ( data.status == 'payment_success' && data.is_data_exists == false && data.is_free == 0 )) {
                    $('#view_free_report').addClass('d-none');
                }
                else if (pathname == '/brand-social-report/pay') {
                    if (data.status == "payment_success") {
                        window.location.href = data.redirect_url;
                    }
                    if (data.message !== undefined && data.message !== "") {
                        $('#price_welcome').addClass('d-none');
                        $('#price_error_message').text(data.message);
                    }

                    // to display report price when load /pay?id={id}&report_code={report_code}
                    var report_price = 0;
                    // Get the URL parameters
                    const urlParams = new URLSearchParams(window.location.search);

                    // Get the value of the 'report_code' parameter
                    const report_code = urlParams.get('report_code');
                    $.each(data.reports, function(index, item) {
                        if (item.type == report_code) {
                            report_price = item.price;
                            return false; // Break out of the loop once the price is found
                        }
                    });
                    $("#report_price").text(report_price);
                    $("#after_discount_price").text(report_price);

                    if (data.pending_voucher_usage) {
                        $("#voucher_code").val(data.pending_voucher_usage.voucher_code);
                        $("#voucher_value").text(data.pending_voucher_usage.voucher_value);
                        // $("#btn_apply_voucher").text('Applied').prop('disabled', true);
                        $("#btn_apply_voucher").text('Apply');
                        
                        $.each(data.pending_voucher_usage.reports, function(index, item) {
                            if (item.type == report_code) {
                                after_discount_price = item.after_discount_price;
                                return false; // Break out of the loop once the price is found
                            }
                        });
                        $("#after_discount_price").text(after_discount_price);
                        if (after_discount_price == 0) {
                            var lastUpdatedTime = new Date(); 
                            $('#last_updated_time').text(formatDate(lastUpdatedTime));
                            $('#btn_paid').removeClass('d-none');
                            $('#text_updated_time').removeClass('d-none');
                        }
                    } else {
                        $("#voucher_code").val("");
                        $("#voucher_value").text(0);
                        $("#btn_apply_voucher").text('Apply').prop('disabled', false);
                    }
                } 
                else if (pathname == '/brand-social-report/buy'){
                    window.location.href = data.redirect_url;
                }
                else if (pathname == '/brand-social-report') {
                    if ((data.status == "limit_reach" || data.status == "pending_verified" || data.status == "pending_data" || data.is_data_exists == false) && data.is_free == 1) {
                        var targetSlideIndex = -1;
                        // Loop through each slide item to find the target slide index
                        $('.owl-item').each(function(index) {
                            // Get the class of the current slide
                            var slideClass = $(this).find('.item').attr('class').split(' ')[1];
                            if (slideClass === data.redirect_item_id) {
                                targetSlideIndex = index;
                                return false; // Exit the loop
                            }
                        });
                        // If a valid target slide index is found, trigger the carousel to move to that slide
                        if (targetSlideIndex !== -1) {
                            carousel.trigger('to.owl.carousel', targetSlideIndex);
                        } else {
                            // Handle when the target slide is not found
                        }

                        if (data.redirect_item_id == 'item-3') { // verify page
                            // add email into verify_report_email
                            var email = data.client.email;
                            if ( email !== undefined ) {
                                $('#verify_report_email').text(email);
                            } else {
                                $('#verify_report_email').text('N/A');
                            }
                        }

                        if (data.redirect_item_id == 'item-4') { //loading page
                            var first_name = data.client.first_name;
                            if ( first_name !== undefined ) {
                                $('#loading_report_first_name').text(first_name);

                                // only url /free need to call loadingPage()
                                loadingPage();

                            } else {
                                $('#loading_report_first_name').text('N/A');
                            }
                        }
                    }
                    else {
                        window.location.href = data.redirect_url;
                    }
                }
            },
            error:function(xhr, textStatus, errorThrown){
                console.log("ERR:- Check Status: "+xhr.responseJSON);
            } 
        });
    }
    
});

module.exports = {
    getUrlParameter: getUrlParameter,
    formatDate: formatDate
};
